import { api } from '@/lib/api'

/**
 * @param {number} serviceId
 */
export async function fetchServiceConsumables(serviceId) {
  const { data } = await api.get(`/masters/services/${serviceId}/consumables`)
  return data.data.consumables
}

/**
 * @param {number} serviceId
 * @param {Array<{ product_id: number, quantity: number }>} lines
 */
export async function updateServiceConsumables(serviceId, lines) {
  const { data } = await api.put(`/masters/services/${serviceId}/consumables`, { lines })
  return data.data.consumables
}
